<template>
    <div class="cent_container">
        <div class="cent_box" v-for="(val,index) in list" :key="index">
            <div class="left_box">
                <el-carousel width="200px" height="200px" :autoplay="false" indicator-position="none">
                    <el-carousel-item v-for="(item,indexs) in val.preview_pic" :key="indexs">
                        <el-image
                        style="width: 200px; height: 200px"
                        :src="item"
                        fit="cover"></el-image>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="right_box">
                <div class="file_details_box">
                    <div class="name_box">
                        <span class="status">{{val.check_status | get_status}}</span>
                        <span class="name">{{val.file_name}}</span>
                    </div>
                    <p class=time>{{val.updated_at}}</p>
                    <p class="download" @click="download(val.file_url,val.file_name)">下载({{val.file_size}})</p>
                </div>
                <div class="doc_box">
                    {{val.remark}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        list:Array
    },
    filters: {
        get_status: function (val) {
            if(val == '0'){
                return '待审核'
            }else if(val == '1'){
                return '已通过'
            }else if(val == '-1'){
                return '已驳回'
            }else if(val == '-2'){
                return '已撤销'
            }
        }
    },
    mounted(){
        this.get_passed()
    },
    methods:{
        get_passed(){
            this.list.forEach((val)=>{
                if(val.check_status == '1'){
                    this.$store.commit("common_vuex/set_file_data",val)
                }
            })
        },
        download(file_url,file_name){
            fetch(file_url).then(res => res.blob()).then(blob => {
				const a = document.createElement('a');
				document.body.appendChild(a)
				a.style.display = 'none'
			    // 使用获取到的blob对象创建的url
				const url = window.URL.createObjectURL(blob);
				a.href = url;
				// 指定下载的文件名
				a.download = file_name;
				a.click();
				document.body.removeChild(a)
				// 移除blob对象的url
				window.URL.revokeObjectURL(url);
			}); 
        }
    }
}
</script>


<style lang="scss" scoped>
.cent_container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .cent_box{
        width: 480px;
        display: flex;
        border: 2px solid #E4E7ED;
        margin: 5px;
        .left_box{
            width: 200px;
            height: 200px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .right_box{
            width: 280px;
            height: 200px;
            border-left: 2px solid #E4E7ED;
            .file_details_box{
                height: 60%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 0 5px;
                .name_box{
                    .status{
                        color:rgb(53, 202, 53);
                        margin-right: 10px;
                    }
                }
                .time{
                    margin: 10px 0;
                }
                .download{
                    color: #33B3FF;
                    cursor:pointer;
                }
            }
            .doc_box{
                border-top: 2px solid #E4E7ED;
                height: 40%;
                padding: 0 5px;
            }
        }
    }
}
</style>